module.exports = __webpack_public_path__ + "img/grey-kapla2.366284b0.png";